import utility from './utility'

export default {
  mixins: [utility]
}
